// TranslatedEditor.jsx

import React, { useState } from "react";
import { Form, ButtonGroup, Button } from "react-bootstrap";
import { Editor } from "@hugerte/hugerte-react";
import i18n from "i18next";

const getFieldName = (baseName, language) => {
  if (language === i18n.language) {
    return baseName;
  }

  return `${baseName}_${language}`;
};

const TranslatedEditor = ({
  name,
  values = {},
  errors = {},
  onChange,
  languages = ["de", "en", "it"],
  initialLanguage = i18n.language,
  label,
  required = false,
  disabled = false,
  hint = "",
}) => {
  const [activeLanguage, setActiveLanguage] = useState(
    languages.includes(initialLanguage) ? initialLanguage : languages[0]
  );

  const fieldName = getFieldName(name, activeLanguage);

  const handleEditorChange = (content) => {
    onChange(fieldName, content);
  };

  return (
    <Form.Group className="mb-3">
      <div className="mb-2">
        <Form.Label className="mb-0">
          {label} {required && "*"}
        </Form.Label>

        {hint && (
          <Form.Text className="text-muted d-block mb-2">{hint}</Form.Text>
        )}

        <ButtonGroup size="sm" className="mb-2">
          {languages.map((language) => (
            <Button
              key={language}
              type="button"
              variant={
                activeLanguage === language ? "primary" : "outline-primary"
              }
              onClick={() => setActiveLanguage(language)}
            >
              {language.toUpperCase()}
            </Button>
          ))}
        </ButtonGroup>
      </div>

      <Editor
        disabled={disabled}
        value={values[fieldName] || ""}
        onEditorChange={handleEditorChange}
        init={{
          height: 400,
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | " +
            "blocks | bold italic forecolor | " +
            "alignleft aligncenter alignright alignjustify | " +
            "bullist numlist outdent indent | " +
            "removeformat | help",
        }}
      />

      {errors?.[fieldName] && (
        <small className="text-danger">{errors?.[fieldName]}</small>
      )}
    </Form.Group>
  );
};

export default TranslatedEditor;
